export const CONFIG = {
    "ORG_NAME": "<org_name>",
    "RESPONSE_TYPE": "code",
    "SCOPE": "openid email profile",
    "REDIRECT_URI": process.env.REACT_APP_COGNITO_REDIRECT_URI,
    "CLIENT_ID": process.env.REACT_APP_COGNITO_CLIENT_ID,
    "CLIENT_SECRET": process.env.REACT_APP_COGNITO_CLIENT_SECRET,
    "GRANT_TYPE": "authorization_code"
};